import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clearCart } = useCart();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearCart();
          return;
        }
      } catch {
        /* keep polling */
      }
      attempts += 1;
      if (attempts < 10) timer = setTimeout(poll, 2000);
      else setStatus("pending");
    };
    if (sessionId) poll();
    else setStatus("pending");
    return () => clearTimeout(timer);
  }, [sessionId, clearCart]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg text-center"
      >
        <CheckCircle2 size={52} className="mx-auto text-[#C9501C]" />
        <h1 className="mt-8 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#2A2118]">
          {status === "paid" ? "It's yours." : "Confirming your order…"}
        </h1>
        <p className="mt-6 text-base leading-relaxed text-[#7A6C5A]" data-testid="payment-success-message">
          {status === "paid"
            ? "Thank you, collector. Your payment is confirmed — mads will personally prepare your piece and email tracking within 3 studio days."
            : "We're confirming your payment with Stripe. This page will update in a moment."}
        </p>
        <Link
          to="/shop"
          data-testid="payment-success-continue-link"
          className="mt-10 group inline-flex items-center gap-3 bg-[#2A2118] text-[#F5E8D0] font-mono-accent text-xs uppercase tracking-[0.3em] px-8 py-4 hover:bg-[#C9501C] hover:text-[#2A2118] transition-colors duration-300"
        >
          Continue browsing
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </motion.div>
    </div>
  );
}
